import {DropDownModel} from "../common/models/dropDown";

export default class NumberDropDownItems {
    public static getNumberDropDownItems (items: number): DropDownModel[] {
        const result = [] as DropDownModel[];

        if (items <= 0) {
            return [];
        }

        for(let i = 1; i <= items; i++) {
            result.push({
                id: i.toString(),
                name: i.toString()
            });
        }

        return result;
    }
}